<template>
  <div>
    <slot name="activator" :on="{ click: clickUploadButton }"> </slot>

    <input ref="uploader" class="d-none" type="file" @change="uploadFile($event.target.files)" />
  </div>
</template>

<script>
export default {
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    clickUploadButton() {
      this.$refs.uploader.click()
    },
    uploadFile(files) {
      this.$emit('update:file', this.multiple === false ? files[0] : files)
      this.$refs.uploader.value = null
    },
  },
}
</script>

<style lang="scss" scoped></style>
